import { SetConsent } from 'src/ConsentManagement/ConsentStorage';
import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';
import { Publish } from 'src/Shared/EventPublisher/EventEmitter';
import { Button } from '../Button';
import { ListOptionState } from '../UiStates/TriStateCheckbox';
import { UsePreferenceSelections } from '../UiStates/UsePreferenceSelections';
import { UseVendorSelections } from '../UiStates/UseVendorSelections';

export const RejectButton = ({ id }: { id: string }) => {
  const { preferenceSelections } = UsePreferenceSelections();
  const { vendorSelections } = UseVendorSelections();
  const SaveOptions = () => {
    const areVendorsFullyOn = vendorSelections.GetOptInStatus() === ListOptionState.all;
    SetConsent(preferenceSelections, areVendorsFullyOn);
    Publish(ConsentEventType.REQUEST_CLOSE_CONSENT_UI);
  };

  return <Button id={id} class="secondary-button ccmgt_reject_button" onClick={SaveOptions} translationKey="reject_button" />;
};
